var _path, _g, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_17067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.621 1C6.547 1 0 7.547 0 15.622C0 23.696 6.547 30.243 14.621 30.243C22.696 30.243 29.243 23.696 29.243 15.622C29.243 7.547 22.696 1 14.621 1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_17067)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.621 1C6.547 1 0 7.547 0 15.622C0 23.696 6.547 30.243 14.621 30.243C22.696 30.243 29.243 23.696 29.243 15.622C29.243 7.547 22.696 1 14.621 1Z",
    fill: "url(#paint0_linear_0_17067)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.16 10.0903C18.605 10.0903 18.155 10.5403 18.155 11.0953C18.155 11.6503 18.605 12.1003 19.16 12.1003C19.715 12.1003 20.165 11.6503 20.165 11.0953C20.165 10.5403 19.715 10.0903 19.16 10.0903Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6917 18.3054C13.2007 18.3054 11.9877 17.0924 11.9877 15.6014C11.9877 14.1094 13.2007 12.8964 14.6917 12.8964C16.1827 12.8964 17.3957 14.1094 17.3957 15.6014C17.3957 17.0924 16.1827 18.3054 14.6917 18.3054ZM14.6917 11.3794C12.3637 11.3794 10.4697 13.2734 10.4697 15.6014C10.4697 17.9294 12.3637 19.8234 14.6917 19.8234C17.0197 19.8234 18.9137 17.9294 18.9137 15.6014C18.9137 13.2734 17.0197 11.3794 14.6917 11.3794Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.199 8.64205C9.24905 8.64205 7.66205 10.2281 7.66205 12.1781V19.0231C7.66205 20.9731 9.24905 22.5601 11.199 22.5601H18.043C19.994 22.5601 21.58 20.9731 21.58 19.0231V12.1781C21.58 10.2281 19.994 8.64205 18.043 8.64205H11.199ZM18.043 24.1731H11.199C8.36005 24.1731 6.05005 21.8631 6.05005 19.0231V12.1781C6.05005 9.33905 8.36005 7.02905 11.199 7.02905H18.043C20.883 7.02905 23.193 9.33905 23.193 12.1781V19.0231C23.193 21.8631 20.883 24.1731 18.043 24.1731Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_17067",
    x1: 29.243,
    y1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320203,
    stopColor: "#F75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592603,
    stopColor: "#D53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802174,
    stopColor: "#8F39CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4FE9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cff14c3b.svg";
export { ForwardRef as ReactComponent };